import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=f72fc70a&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f72fc70a')) {
      api.createRecord('f72fc70a', component.options)
    } else {
      api.reload('f72fc70a', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=f72fc70a&", function () {
      api.rerender('f72fc70a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26jlLO5SEQX33/JS/imageCarousel.vue"
export default component.exports